var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('video',{ref:"video",attrs:{"loop":""}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})]),_vm._v(" "),_c('div',{staticClass:"control",on:{"click":_vm.toggle}},[(_vm.showCover)?_c('div',{staticClass:"cover",style:({ backgroundImage: 'url(' + _vm.cover + ')' })}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9275c71a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = 350
// module chunks = 1